import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const { t, i18n } = useTranslation();
  
  const scrollToTradingWidget = () => {
    const tradingSection = document.querySelector('#trading-widget');
    if (tradingSection) {
      tradingSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <section className="relative bg-gray-900 pt-20 pb-32 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/3db1c6f20a9d8586b824fc7d915d46a2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/80 to-gray-900/60"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
            {i18n.language === 'ja' ? (
              <>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                  DP Crypt
                </span>
                でUSDTを即座に購入
              </>
            ) : (
              <>
                Buy USDT Instantly with{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                  DP Crypt
                </span>
              </>
            )}
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            {t('hero.description')}
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <Button size="lg" className="text-lg whitespace-nowrap" onClick={scrollToTradingWidget}>
              <i className="ri-shopping-cart-line mr-2"></i>
              {t('hero.cta.buy')}
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap items-center gap-8">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-green-400 text-2xl"></i>
              <span className="text-gray-300 text-sm">{t('hero.trust.secure')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line text-blue-400 text-2xl"></i>
              <span className="text-gray-300 text-sm">{t('hero.trust.instant')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-customer-service-2-line text-purple-400 text-2xl"></i>
              <span className="text-gray-300 text-sm">{t('hero.trust.support')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
